window.Vue = require('vue');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

window.Vue.use(VueSweetalert2);


window.Bus = new Vue();

Vue.component('home', require('./components/Home.vue').default);
Vue.component('navbar', require('./components/Navbar.vue').default);
Vue.component('products', require('./components/Products.vue').default);
Vue.component('product-details', require('./components/ProductDetails.vue').default);
Vue.component('cart', require('./components/Cart.vue').default);
Vue.component('checkout', require('./components/Checkout.vue').default);
Vue.component('payment', require('./components/Payment.vue').default);
Vue.component('wishlist', require('./components/Wishlist.vue').default);
Vue.component('login', require('./components/Login.vue').default);
Vue.component('register', require('./components/Register.vue').default);
Vue.component('forgot-password', require('./components/ForgotPassword.vue').default);
Vue.component('reset-password', require('./components/ResetPassword.vue').default);
Vue.component('verify-otp', require('./components/VerifyOtp.vue').default);
Vue.component('blog-details', require('./components/BlogDetails.vue').default);
Vue.component('footer-section', require('./components/home_sections/FooterSection.vue').default);

Vue.component('auth-check', require('./components/AuthCheck.vue').default);

const app = new Vue({
    el: '#app',
    data: {
        authUser: null
    },
    mounted() {
        window.Bus.$on('auth-user-updated', (user) => {
            this.authUser = user;
            Vue.prototype.$auth = user;
        });
    }
});
